module.exports = __webpack_public_path__ + "img/profitable-img-mobile-3.083f9323.png";